import { render, staticRenderFns } from "./ExamineActivity.vue?vue&type=template&id=3b645c36&style=height%3A%20100%25%3B"
import script from "./ExamineActivity.vue?vue&type=script&lang=js"
export * from "./ExamineActivity.vue?vue&type=script&lang=js"
import style0 from "./ExamineActivity.vue?vue&type=style&index=0&id=3b645c36&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports